import workspaceQuery from 'graphql/queries/supplier/PurchaseVatOnlyWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchaseVatOnlyQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchaseVatOnlyDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchaseVatOnlyMutation.graphql';
import fragment from 'graphql/fragments/supplier/PurchaseVatOnlyFragment.graphql';
import temporaryMutationQuery from 'graphql/mutations/supplier/SavePurchaseVatOnlyTempMutation.graphql';

import { formActions } from 'actions/supplier/PurchaseVatOnlyAction';

const PurchaseVatOnly = {
  type: 'PurchaseVatOnly',
  title: 'Vat Only Invoice/Credit',
  formTitle: 'Vat Only Invoice/Credit',
  formUrl: '/Suppliers/VatOnly/Details/',
  workspaceUrl: '/Suppliers/VatOnly/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'SUPPLIER_VATONLY',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default PurchaseVatOnly;
